import Check from '@mui/icons-material/Check';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CheckIcon(props: FixMe) {
  return <Check {...props} />;
}

export default CheckIcon;
